import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../_metronic/_partials/controls';
import { IAlertModel } from '../models/LeadTimes';
import ProductsTableWithSchedules from './products-table/ProductsTableWithSchedules';
import { LeadTimesExportImportCard } from './components/leadtimes-export-import-card/LeadTimesExportImportCard';

import { useProductsContext } from './ProductsContext';

type Props = {
  cardProps?: any;
  downloadLeadTimesHandler: () => Promise<void>;
  showImportModalHandler: () => void;
  leadTimesAlert?: IAlertModel | null; 
  hasLeadTimesUpdated? : boolean;
};

const ProductsCard = (props: Props) => {
  const productsContext = useProductsContext();
  const downloadLabel = `Download ${productsContext.productGroupName} Lead times`;
  const importLabel = 'Import Product Lead times';

  const [filterQuery, setFilterQuery] = useState('');

  const handleFilter = (query: string) => {
    setFilterQuery(query);
  };

  return (
    <Card {...props.cardProps}>
      <CardHeader
        className='border-0'
        title={`${productsContext.productGroupName} Lead Times`}
        {...props.cardProps}
      >
        <CardHeaderToolbar {...props.cardProps}></CardHeaderToolbar>
      </CardHeader>
      <LeadTimesExportImportCard
        alert={props.leadTimesAlert}
        downloadHandler={props.downloadLeadTimesHandler}
        downloadLabel={downloadLabel}
        productGroupName={productsContext.productGroupName}
        showImportModalHandler={props.showImportModalHandler}
        uploadLabel={importLabel}
        showFilter={true}
        handleFilter={handleFilter}
      />
      <CardBody {...props.cardProps}>
        <ProductsTableWithSchedules hasLeadTimesUpdated={props.hasLeadTimesUpdated} filterQuery={filterQuery} />
      </CardBody>
    </Card>
  );
};

export default ProductsCard;
